import React from 'react';

const ExpressCheckoutAbout = () => {
  return (
    <div className="about-content">
      <h3>Documentation</h3>
      <ul>
        <li>
          <a href="https://docs.stripe.com/elements/express-checkout-element/accept-a-payment" target="_blank" rel="noopener noreferrer">
            Accept a Payment
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ExpressCheckoutAbout;
